import {MODAL_BUTTONS} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronDownSmall, ChevronUpSmall} from '@wix/wix-ui-icons-common/on-stage'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import {LegendItem} from './item'
import {classes} from './legend.st.css'
import {LegendProps} from './index'

export const Legend = ({legendItems, seatingMapButtonClick}: LegendProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const [expanded, setExpanded] = React.useState(false)

  const handleClick = () => {
    seatingMapButtonClick(expanded ? MODAL_BUTTONS.HIDE_PRICES : MODAL_BUTTONS.SHOW_PRICES)
    setExpanded(!expanded)
  }

  return (
    <div
      className={classNames(classes.container, {
        [classes.desktopContainer]: !isMobile,
      })}
      onClick={handleClick}
      onWheelCapture={e => e.stopPropagation()}
      data-hook={DH.PRICES_LEGEND}
    >
      <TextButton
        priority={TextButtonPriority.secondary}
        className={classes.label}
        suffixIcon={expanded ? <ChevronDownSmall /> : <ChevronUpSmall />}
        tabIndex={-1}
      >
        {expanded ? t('seatings_legend_title_expanded') : t('seatings_legend_title')}
      </TextButton>
      <ul aria-hidden={!expanded} className={classNames(classes.list, {[classes.listExpanded]: expanded})}>
        {legendItems.map(({color, price, name}, index) => (
          <LegendItem key={index} color={color} price={price} name={name} />
        ))}
      </ul>
    </div>
  )
}
